export default __webpack_public_path__ + "static/media/avatar-shanai.4bbe2f95.png";